import { useTranslation } from 'react-i18next';
import { BaseModal, BaseModalProps } from '@anytag/shared-atoms';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { AnalyticsComparableAccountType } from './types';

export interface DeleteAnalyticsComparableAccountModalProps<T extends AnalyticsComparableAccountType>
  extends Omit<BaseModalProps, 'open' | 'footer'> {
  loading?: boolean;
  onSubmit?: () => void;
  deletingAccount?: T | null;
}
export const DeleteAnalyticsComparableAccountModal = <T extends AnalyticsComparableAccountType>({
  loading,
  onClose,
  onSubmit,
  deletingAccount,
  ...restProps
}: DeleteAnalyticsComparableAccountModalProps<T>) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      size="content"
      onClose={onClose}
      open={!!deletingAccount}
      title={t('Dialog.Delete comparable account')}
      description={t('Dialog.DeleteComparableAccountWarning')}
      footer={{
        cancelButton: { title: t('Button.Cancel'), onClick: onClose },
        submitButton: { loading, color: 'danger', onClick: onSubmit, title: t('Button.Delete') }
      }}
      {...restProps}
    >
      <div className="flex items-center">
        <InfluencerAvatar src={deletingAccount?.avatarUrl} size="40px" className="rounded-full" />
        <p className="ml-2 text-base">{deletingAccount?.username}</p>
      </div>
    </BaseModal>
  );
};
